import { render, staticRenderFns } from "./SerialList.vue?vue&type=template&id=4c0a62c2&scoped=true"
import script from "./SerialList.vue?vue&type=script&lang=js"
export * from "./SerialList.vue?vue&type=script&lang=js"
import style0 from "./SerialList.vue?vue&type=style&index=0&id=4c0a62c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0a62c2",
  null
  
)

export default component.exports